import Head from "next/head";
import ContactUsTemplate from "../components/Templates/ContactUs";
import { withApollo } from "../graphql/withApollo";

function ContactUs() {
  return (
    <>
      <Head>
        <title>Contact Us - MagicalTrip</title>
      </Head>
      <ContactUsTemplate />
    </>
  );
}

export default withApollo(ContactUs);
